import objectFitImages from "object-fit-images";
import Accordion from "./accordion";
import BlogNavigation from "./blog-navigation";
import FacetedSearchExpandSummary from "./faceted-search-expand-summary";
import GeoDataIframeResizer from "./geometric-datasource";
import * as Legacy from "./legacy"; // eslint-disable-line
import ResearchLab from "./research-lab";
import Scrollbar from "./scrollbar";
import TableOfContents from "./table-of-contents";
import VideoA11y from "./video-a11y";
import "./autosuggest";
import RegionSort from "./region-sort";
import "./mwf-nav-tabs";
import "../lib/responsive-tables";
import MorayModal from "./moray-modal";
import OnDemand from "./on-demand";
import ClickGroupOverride from "./overrides/click-group";
import Sessions from "./sessions";
import Toggle from "./toggle";
import "./translatepress";
import "./show-more";
import LanguagePicker from "./language-picker";
import MorayTabsA11y from "./shims/moray-tabs-accessibility";

objectFitImages();
BlogNavigation();
FacetedSearchExpandSummary();
ResearchLab();
VideoA11y();
new Accordion(".accordion");
TableOfContents();
GeoDataIframeResizer();
RegionSort();
Scrollbar();
Toggle();
OnDemand();
Sessions();
MorayModal();
ClickGroupOverride();
MorayTabsA11y();
LanguagePicker();
